// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1ed0c42c","832":"e5d795db"}[chunkId] + ".chunk.js";
};